import { Component } from '@angular/core';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    host: { 'class': 'home component' }
})
export class HomeComponent {
}



// WEBPACK FOOTER //
// ./client-src/app/eStore/components/home/home.component.ts